module.exports = __webpack_public_path__ + "static/startingstyletoggle-0002efc1c40a4613f40dd09997dc16e9.png";